export default "__VITE_ASSET__CWX7XU53__"